import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from "react-i18next";
import { ExtraItemConfig, getBookingConfig } from "../../data/price";
import { FormType } from '../../types/types';
import DeliveryOptions from './DeliveryOptions';
import { DeliveryManager } from '../../data/DeliveryManager';

interface ExtraItemCardProps extends ExtraItemConfig{
    setExtraItemQuantity: (quantity: number) => void,
    extraItemQuantity: number,
    onClick: (type: string, selected: boolean) => void,
    formType: FormType,
    numFree: number
}

const ExtraItemCard: FC<ExtraItemCardProps> = ({
                                                   setExtraItemQuantity,
                                                   itemPrice,
                                                   maxDropdownLength,
                                                   imageUrl,
                                                   slug,
                                                   batchSize,
                                                   extraItemQuantity,
                                                   onClick,
                                                   min,
                                                   formType,
                                                   numFree
                                               }) => {
    const {t} = useTranslation();
    const [isSelected, setSelected] = useState(true);
    const handleClick = (selected: boolean) => {
        setSelected(selected);
        onClick(slug, selected);
        if (selected) {
            setExtraItemQuantity(extraItemQuantity === 0 ? (min ?? 1) : extraItemQuantity);
        }
    }

    function calcQuantityForPrice(quantity: number, numFree: number): number {
        let result = quantity - numFree;
        if (result < 0) {
            result = 0;
        }
        return result;
    }

    const itemsFree = numFree * batchSize;
    const plural = itemsFree > 1 ? 's' : ''; 

    // console.log('ExtraItemCard', slug, extraItemQuantity, isSelected);
    return (
        <div className="extra-item-row">
            <div className="extra-item-box">
                <div className='extra-item-image-div'>
                    <img src={imageUrl} alt={t(`extra.${slug}.title`)} />
                </div>
                <div
                    className={"text-center h-10 bg-gradient-to-b from-transparent to-orange-300 extra-title-bar" + (isSelected ? ' shadow-lg shadow-amber-600' : '')}>
                    <span
                        className="pt-2 inline-block align-text-bottom font-bold">{t('extra.' + slug + '.title')}</span>
                </div>
            </div>
            {isSelected && <div className="w-full lg:w-1/3 p-2 lg:p-6">
                <div>{t('extra.' + slug + '.description')}</div>
                <b>{t('extra.' + slug + '.priceText')}</b>
                <div>{t('extra.' + slug + '.price')}</div>
            </div>
            }
            {isSelected && <div className="w-full lg:w-1/3 p-2 lg:p-6">
                <div>{t('extra.' + slug + '.dropdownLabel')}</div>
                <div className="flex justify-center flex-col">
                    <div className="mb-3 xl:w-full">
                        <select className="form-select appearance-none
                              block
                              w-full
                              px-3
                              py-1.5
                              text-base
                              font-normal
                              text-gray-700
                              bg-white bg-clip-padding bg-no-repeat
                              border border-solid border-orange-200
                              rounded
                              m-0
                              focus:text-gray-700
                              focus:bg-white
                              focus:border-orange-200
                              focus:shadow-none
                              focus:outline-none"
                                onChange={(e) => setExtraItemQuantity(parseInt(e.target.value))}
                                defaultValue={min ?? 1}
                                value={extraItemQuantity}>
                                <option value="0">{t('selectAmount')}</option>
                                {Array.from({length: maxDropdownLength}, (item, index) => {
                                    const quantity = (index + 1);
                                    if (min && quantity < min) {
                                        return "";
                                    }
                                    return <option key={index}
                                                value={quantity}>{t('extra.' + slug + '.optionText', {
                                        quantity: quantity * batchSize,
                                        price: itemPrice * calcQuantityForPrice(quantity, numFree),
                                    })}</option>
                                })}
                        </select>
                        {numFree > 0 &&
                            <div className="text-green-500">{`${numFree * batchSize} ${t('extra.freeExtra')}${plural}`}</div>
                        }
                    </div>
                    {isNaN(extraItemQuantity) &&
                        <div className="mb-3 xl:w-full text-red-500">{t('errors.extraItemQuantityZero')}</div>
                    }
                </div>
            </div>
            }
        </div>
    );
};

export default ExtraItemCard;
